import React from "react";
import {assetMasterImport, getResource, getResourceForImport} from "../../appRedux/actions/Organisation";
import {connect} from "react-redux";
import {Button, Card, Checkbox, Form, Input, Select, Spin} from "antd";
import {faviconDynamicFunction} from "../../util/methods";

class AssetMasterImport extends React.Component {
    state = {
        file: {},
        isForRemove: false,
    }
    createResource = (values) => {
        this.props.createResource(values);
    };

    componentDidMount() {
        this.props.getResourceForImport();
    }

    onFileUpload = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (err) {
                return console.log(err);
            }
            if (values.organisation && this.state.file) {
                this.props.assetMasterImport({
                    organisation: values.organisation,
                    file: this.state.file
                });
            }
            this.props.form.resetFields();
        });
    }

    onFileChange = e => {
        this.setState({file: e.target.files[0]});
    }

    render() {
        const {match, resource, loading, authUser, resourceName, data, importData} = this.props;
        faviconDynamicFunction(authUser);
        const {getFieldDecorator} = this.props.form;
        // console.log(importData);
        return (
            <Spin spinning={loading}>
                <Card className={`gx-card-metrics`}>
                    <h2>Asset Master Import</h2>
                    <div style={{ width: '100%'}}>
                        <div style={{overflowX: 'auto'}}>
                            <table style={{width: '100%', border: '1px dashed #ccc444'}}>
                                <tbody>
                                <tr>
                                    <td>Asset Type</td>
                                    <td>Asset Sub Type</td>
                                    <td>Asset Sub Type Code</td>
                                    <td>Model</td>
                                    <td>Make</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <Form onSubmit={this.onFileUpload} style={{width: '60%'}}>
                            <Form.Item label="Select Organisation">
                                {getFieldDecorator("organisation", {
                                    rules: [{required: true, message: `Organisation is required!`}],
                                })(
                                    <Select
                                        mode='single'
                                        showSearch
                                        allowClear
                                        placeholder={'Select Organisation'}
                                        filterOption={(input, option) =>
                                            option.props.children
                                                .toLowerCase()
                                                .indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {this.props && this.props.data && this.props.data.length && this.props.data.map(org =>
                                            <Select.Option key={org._id} value={org._id}>{org.name}</Select.Option>
                                        )}
                                    </Select>)}
                            </Form.Item>

                            <Form.Item label={'File:'}>
                                {getFieldDecorator("file", {
                                    rules: [{required: true, message: `File is required!`}],
                                })(
                                    <Input
                                        type="file"
                                        accept=".csv"
                                        onChange={this.onFileChange}
                                    />)}
                            </Form.Item>

                            <Form.Item>
                                <Button
                                    type="primary"
                                    className="gx-mb-0"
                                    htmlType="submit"
                                    loading={loading}
                                >
                                    {'Upload'}
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </Card>
            </Spin>)
    }
}

const mapStateToProps = ({commonData, auth, organisation}) => {
    return {
        authUser: auth.authUser,
        loading: commonData.loading,
        modules: commonData.modules,
        data: organisation.resources,
        importData: organisation.importData,
    }
};

function mapDispatchToProps(dispatch) {
    return {
        getResource,
        getResourceForImport,
        assetMasterImport,
    };
}

const AssetMasterDataImport = connect(mapStateToProps, mapDispatchToProps())(AssetMasterImport);
export default Form.create({name: 'upload'})(AssetMasterDataImport);


